import Handlebars from 'handlebars';

export default Handlebars.compile(`
select{{#each groupByList}}
    {{{sqlExpression}}} as [{{name}}],{{/each}}
    count(*) as count_rows
from
    {{deSourceName}} as src{{#if customWhereClause}}
where ({{{customWhereClause}}}){{/if}}
group by{{#each groupByList}}
    {{{sqlExpression}}}{{#unless @last}},{{/unless}}{{/each}}
`);